import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { SessionService } from '@auth/auth';
import { map, Observable } from 'rxjs';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private sessionService: SessionService) {}

  canActivate(): Observable<boolean> | boolean {
    return this.sessionService.isAuthenticated$.pipe(
      map((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          return true;
        } else {
          return this.handleNotAuthenticated();
        }
      })
    );
  }

  private handleNotAuthenticated(): boolean {
    // We need to remove the trailing slash because routes of some MFE aren't able to handle it (like in Analytics)
    const path = window.location.pathname.replace(/\/$/, '') || '/';

    if (path.includes('session/')) {
      // This is to avoid infinite loop.
      return true;
    } else {
      this.sessionService.login({
        appState: {
          target: path + window.location.search
        }
      });
      return false;
    }
  }
}
